import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect'
import { routerActions } from 'react-router-redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount, selectIsAdmin, selectIsOperator, selectIsCallCentrum } from '../ducks';
import { accountRoles } from '../../../common/enums';

export default connectedRouterRedirect({
  authenticatedSelector: state => selectAccount(state) === null,
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: state => {
    if (selectIsAdmin(state) || selectIsOperator(state)) return '/admin';
    if (selectIsCallCentrum(state)) return '/cc';
    return '/dashboard';
  },
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'IsAnonymous',
  allowRedirectBack: false,
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/IsAnonymous.js